'use client';

import { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

type FormState = {
  fullName: string;
  phone: string;
  city: string;
  category: string;
  description: string;
};

export default function BasvuruPage() {
  const [form, setForm] = useState<FormState>({
    fullName: '',
    phone: '',
    city: '',
    category: '',
    description: '',
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleChange = (field: keyof FormState, value: string) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const submitForm = async () => {
    setMessage('');

    if (!form.fullName || !form.phone || !form.city || !form.category) {
      setMessage('Lütfen zorunlu alanları doldurun.');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch('/api/applications', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });

      if (!response.ok) {
        throw new Error('API hata döndürdü');
      }

      setMessage('Başvurunuz başarıyla alındı. En kısa sürede sizinle iletişime geçeceğiz.');
      setForm({ fullName: '', phone: '', city: '', category: '', description: '' });
    } catch {
      setMessage('Başvuru gönderilemedi. Lütfen daha sonra tekrar deneyin.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main style={styles.main}>
      <Header />

      <section style={styles.hero}>
        <h1 style={styles.title}>Kurucu Usta Başvurusu</h1>
        <p style={styles.desc}>
          UstamGelsin yayına alınmadan önce ön kayıt oluşturun. İlk katılan ustalar için avantajlı dönem başlıyor.
        </p>
      </section>

      <section style={styles.formBox}>
        <input style={styles.input} placeholder="Ad Soyad / Firma Adı *" value={form.fullName} onChange={(e) => handleChange('fullName', e.target.value)} />
        <input style={styles.input} placeholder="Telefon Numaranız *" value={form.phone} onChange={(e) => handleChange('phone', e.target.value)} />
        <input style={styles.input} placeholder="Şehir / İlçe *" value={form.city} onChange={(e) => handleChange('city', e.target.value)} />

        <select style={styles.input} value={form.category} onChange={(e) => handleChange('category', e.target.value)}>
          <option value="">Hizmet Kategorisi Seçin *</option>
          <option>Elektrik</option>
          <option>Su Tesisatı</option>
          <option>Boya Badana</option>
          <option>Kombi / Petek</option>
          <option>Tadilat</option>
          <option>Temizlik</option>
          <option>Diğer</option>
        </select>

        <textarea style={styles.textarea} placeholder="Kısa açıklama yazın" value={form.description} onChange={(e) => handleChange('description', e.target.value)} />

        <button type="button" style={styles.submitButton} onClick={submitForm} disabled={loading}>
          {loading ? 'Gönderiliyor...' : 'Başvurumu Gönder'}
        </button>

        {message && (
          <div style={message.includes('başarıyla') ? styles.success : styles.error}>
            {message}
          </div>
        )}
      </section>

      <Footer />
    </main>
  );
}

const styles: Record<string, React.CSSProperties> = {
  main: { fontFamily: 'Arial, sans-serif', color: '#20283a' },
  hero: { maxWidth: 900, margin: '0 auto', padding: '50px 20px 20px', textAlign: 'center' },
  title: { fontSize: 46, color: '#172033', margin: '0 0 12px' },
  desc: { fontSize: 18, color: '#5b6475', lineHeight: 1.6 },
  formBox: {
    maxWidth: 580,
    margin: '25px auto 60px',
    background: 'white',
    padding: 34,
    borderRadius: 24,
    boxShadow: '0 12px 35px rgba(0,0,0,0.10)',
    display: 'flex',
    flexDirection: 'column',
    gap: 14,
  },
  input: { padding: '15px 16px', borderRadius: 12, border: '1px solid #ddd', fontSize: 16 },
  textarea: { padding: '15px 16px', borderRadius: 12, border: '1px solid #ddd', fontSize: 16, height: 120, resize: 'vertical' },
  submitButton: { background: '#e85d3f', color: 'white', padding: 16, border: 'none', borderRadius: 12, fontSize: 17, fontWeight: 800, cursor: 'pointer' },
  success: { background: '#e8f8ef', color: '#157347', padding: 14, borderRadius: 12, textAlign: 'center', fontWeight: 800 },
  error: { background: '#fff0f0', color: '#c0392b', padding: 14, borderRadius: 12, textAlign: 'center', fontWeight: 800 },
};
